/**
 * Component types that use native HTML sync in HTMLRenderer.
 */
export var NATIVE_HTML_COMPONENTS = new Set([
    'button',
    'checkbox',
    'toggle',
    'slider',
    'radio',
    'progressBar',
    'card',
    'tabs',
    'accordion',
    'table',
    'tree',
    'toolbar',
    'toast',
    'menu',
    'dialog',
    'tooltip',
    'statusBar',
]);
